<template>
  <div>
    <v-container>
      <v-row no-gutters>
        <v-col cols="4">
          <v-select
            v-model="study"
            :items="studies"
            item-title="name"
            item-value="id"
            label="Форма обучения"
            :menu-props="{ scrim: true, scrollStrategy: 'close' }"
            @update:modelValue="
              loading = true;
              getDataBook(study);
            "
          ></v-select>
        </v-col>
        <v-col cols="auto">
          <v-btn
            color="green"
            variant="text"
            icon="mdi-microsoft-excel"
            @click="printExcel()"
          ></v-btn>
        </v-col>
      </v-row>
    </v-container>
    <div v-show="!loading">
      <v-card>
        <template v-slot:text>
          <v-text-field
            v-model="search"
            label="Поиск"
            hide-details
            prepend-inner-icon="mdi-magnify"
            variant="underlined"
          ></v-text-field>
        </template>
        <v-data-table-server
          :headers="headers"
          :items="bookData"
          :search="search"
          :items-per-page-options="[15]"
          :items-per-page="15"
          :items-length="count"
          @update:options="setNumPage"
        >
          <template v-slot:body="{ items }">
            <tr v-for="(item, rowNum) in items" :key="rowNum">
              <!-- rows -->
              <!-- cols -->
              <template v-for="(val, colNum) in item">
                <td
                  :key="colNum"
                  v-if="colNum != 'id'"
                  @click.stop="editItem(rowNum, colNum)"
                >
                  <span
                    v-if="
                      !editedCell ||
                      editedCell.colNum != colNum ||
                      editedCell.rowNum != rowNum
                    "
                    >{{ val }}</span
                  >
                  <v-textarea
                    width="500"
                    auto-grow
                    rows="1"
                    @blur="editedCell = null"
                    :autofocus="true"
                    v-model="items[rowNum][colNum]"
                    @change="
                      setValue(item.id, items[rowNum][colNum], pagination)
                    "
                    @keydown.enter="
                      setValue(item.id, items[rowNum][colNum], pagination)
                    "
                    v-else
                  ></v-textarea>
                </td>
              </template>
            </tr>
          </template>
        </v-data-table-server>
      </v-card>
    </div>
    <div v-show="loading">
      <v-skeleton-loader type="card"></v-skeleton-loader>
    </div>
  </div>
</template>

<script>
export default {
  name: "alphabetBook",
  data() {
    return {
      editedCell: null,
      studies: [],
      search: "",
      study: "",
      count: 1,
      loading: false,
      bookData: [],
      headers: [
        {
          title: "№№ по поименной книге учащихся",
          key: "book_number",
          align: "start",
        },
        { title: "ФИО", key: "name" },
        { title: "дата рождения", key: "birthday" },
        { title: "Пол", key: "gender" },
        { title: "Домашний адрес", key: "address" },
        { title: "Дата зачисления в учебное заведение", key: "create_order" },
        { title: "Какой профессии обучается", key: "specialty" },
        { title: "Срок обучения", key: "ed_time" },
        {
          title: "Дата и № приказа об отчислении/выпуске",
          key: "delete_order",
        },
        { title: "Присвоенная квалификация", key: "qualification" },
        {
          title: "Наименование документа об окончании учебного заведения",
          key: "diplom_name",
        },
        { title: "Награды и поощрения за время обучения", key: "honors" },
        {
          title: "Предприятие, на которое направлен выпуск учебного заведения",
          key: "job",
        },
        { title: "Разные отметки", key: "notes" },
      ],
      pageNum: 1,
    };
  },
  created() {
    this.axios
      .post(
        this.$model.wwwroot +
          "/procollege/manage_groups/secretariat/alphabetBook/getStudies"
      )
      .then((response) => {
        this.studies = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  methods: {
    setNumPage({ page }) {
      this.pageNum = page - 1;
      if (this.study) {
        this.loading = true;
        this.getDataBook(this.study);
      }
    },
    getDataBook(study_id) {
      this.axios
        .post(
          this.$model.wwwroot +
            "/procollege/manage_groups/secretariat/alphabetBook/getDataBook",
          new URLSearchParams({
            studyId: study_id,
            pageNum: this.pageNum,
          })
        )
        .then((response) => {
          this.bookData = response.data.data_book;
          this.count = response.data.count;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },
    editItem(rowNum, colNum) {
      this.editedCell = {};
      this.editedCell.rowNum = rowNum;
      this.editedCell.colNum = colNum;
    },
    setValue(id, value) {
      if (this.editedCell) {
        this.axios
          .post(
            this.$model.wwwroot +
              "/procollege/manage_groups/secretariat/alphabetBook/setBookColumnData",
            new URLSearchParams({
              data: JSON.stringify({
                id: id,
                value: value,
                param_name: this.editedCell.colNum,
              }),
            })
          )
          .then((response) => {})
          .catch((error) => {
            console.log(error);
          });

        this.editedCell = null;
      }
    },
    printExcel() {
      let studyId = 0;
      if (this.study) {
        studyId = this.study;
      }

      this.axios
        .post(
          this.$model.wwwroot +
            "/procollege/manage_groups/secretariat/alphabetBook/printExcel",
          new URLSearchParams({
            studyId: studyId,
          }),
          {
            responseType: "blob",
          }
        )
        .then((response) => {
          let link = document.createElement("a");
          link.href = URL.createObjectURL(response.data);

          let filename = "AlphabetBook.xlsx";

          link.download = filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>